import {EventSubscriber} from "@/modules/base/events";
import {injectable} from "inversify";
import {Application} from "@/di";
import {RouteRecordRaw} from "vue-router";
import {BaseEntity} from "@/modules/base/entity/BaseEntity";
import {translator} from "@/modules/vue/i18n";

type TranslationObject = { [key: string]: string | TranslationObject };

@injectable()
export class Module {
  protected app: Application;
  protected eventSubscribers: Array<new (...args: any[]) => EventSubscriber> = [];
  public entities: Array<new (...args: any[]) => BaseEntity> = [];
  public dependsOn: Array<new () => Module> = [];
  public messages: { [key: string]: TranslationObject };
  public routes: RouteRecordRaw[] = [];
  public assets: string[] = [];

  static getId(): string {
    return this.name;
  }

  public setApplication(app: Application): this {
    this.app = app;

    return this;
  }

  public init(): void {
    this.eventSubscribers.forEach(eventSubscriber => {
      this.app.bind<EventSubscriber>("EventSubscriber").to(eventSubscriber);
    });

    this.register();

    if (this.messages) {
      collect(this.messages).each((messages, locale) => translator.mergeLocaleMessage(locale as string, messages));
    }
  }

  protected register(): void {
    return;
  }

  public boot(): void {
    return;
  }
}
